import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Menu, X, MessageCircle } from "lucide-react";
import { NAV_LINKS, waLink } from "../../lib/site";
import { scrollToId } from "../../lib/scroll";
import Logo from "./Logo";

export default function Nav() {
  const [open, setOpen] = useState(false);
  const go = (href) => (e) => {
    e.preventDefault();
    setOpen(false);
    scrollToId(href);
  };
  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-gold/15 bg-navy-950/85 backdrop-blur-xl" data-testid="site-nav">
      <div className="mx-auto flex h-[68px] max-w-7xl items-center justify-between px-4 sm:px-6">
        <a href="#home" onClick={go("#home")} aria-label="Tricity Kroonerz home" data-testid="nav-logo-link">
          <Logo />
        </a>
        <nav className="hidden items-center gap-5 lg:flex" aria-label="Primary">
          {NAV_LINKS.slice(1).map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={go(l.href)}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="whitespace-nowrap text-[13px] font-semibold text-slate-300 transition-colors hover:text-gold"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <button
            onClick={go("#book")}
            data-testid="nav-book-us-button"
            className="hidden rounded-full bg-gold px-5 py-2.5 text-[13px] font-bold text-navy-950 transition-colors hover:bg-gold-light sm:block"
          >
            Book Us
          </button>
          <button
            className="rounded-lg p-2 text-ivory lg:hidden"
            onClick={() => setOpen(true)}
            aria-label="Open menu"
            data-testid="nav-menu-open-button"
          >
            <Menu className="h-6 w-6" />
          </button>
        </div>
      </div>
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-[70] flex flex-col bg-navy-950/97 backdrop-blur-xl lg:hidden"
            data-testid="mobile-nav-drawer"
          >
            <div className="flex h-[68px] items-center justify-between border-b border-navy-700 px-4">
              <Logo />
              <button onClick={() => setOpen(false)} aria-label="Close menu" data-testid="nav-menu-close-button" className="rounded-lg p-2 text-ivory">
                <X className="h-6 w-6" />
              </button>
            </div>
            <nav className="flex flex-1 flex-col gap-1 overflow-y-auto px-6 py-8" aria-label="Mobile">
              {NAV_LINKS.map((l, i) => (
                <motion.a
                  key={l.href}
                  href={l.href}
                  onClick={go(l.href)}
                  initial={{ opacity: 0, x: -16 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: 0.05 * i }}
                  data-testid={`mobile-nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                  className="border-b border-navy-800 py-4 font-serif text-2xl text-ivory transition-colors hover:text-gold"
                >
                  {l.label}
                </motion.a>
              ))}
            </nav>
            <div className="flex gap-3 p-6">
              <button onClick={go("#book")} data-testid="mobile-nav-book-button" className="flex-1 rounded-full bg-gold py-3.5 text-sm font-bold text-navy-950">
                Book Us
              </button>
              <a href={waLink()} target="_blank" rel="noreferrer" data-testid="mobile-nav-whatsapp-button" className="flex flex-1 items-center justify-center gap-2 rounded-full bg-[#1f9e4d] py-3.5 text-sm font-bold text-white">
                <MessageCircle className="h-4 w-4" /> WhatsApp
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}
